import styled from 'styled-components';
import {
  borderRadius,
  BorderRadiusProps,
  color,
  ColorProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
} from 'styled-system';
type CodeBlockProps = ColorProps &
  BorderRadiusProps &
  MarginProps &
  PaddingProps;

export const CodeBlock = styled.code<CodeBlockProps>`
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.radii[1]}px;
  border: 1px solid ${({ theme }) => theme.colors.gray.extraLight};

  ${margin};
  ${color};
  ${borderRadius};
  ${padding};
`;

export const InputHint = styled.div<MarginProps>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space[2]}px;

  ${margin};
`;
export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[5]}px;
`;
